import { useEffect, useState } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

interface NetworkBannerProps {
  isVisible: boolean;
  onRetry?: () => void;
  lang?: 'fr' | 'en';
}

export function NetworkBanner({ isVisible, onRetry, lang = 'fr' }: NetworkBannerProps) {
  const [showRetry, setShowRetry] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => setShowRetry(true), 10000);
      return () => clearTimeout(timer);
    } else {
      setShowRetry(false);
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-gray-900 text-white text-sm px-4 py-2.5 flex items-center justify-center gap-3">
      <WifiOff size={16} className="flex-shrink-0" />
      <span className="font-medium">
        {showRetry 
          ? (lang === 'fr' ? 'Le service est momentanément indisponible' : 'The service is temporarily unavailable')
          : (lang === 'fr' ? 'Connexion perdue. Vérification en cours…' : 'Connection lost. Reconnecting…')}
      </span>
      {showRetry && onRetry && (
        <button
          onClick={onRetry}
          className="flex items-center gap-1.5 px-3 py-1 bg-white/10 hover:bg-white/20 rounded text-xs font-medium transition-colors"
        >
          <RefreshCw size={12} />
          {lang === 'fr' ? 'Réessayer' : 'Try again'}
        </button>
      )}
    </div>
  );
}
